import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APAddCategory = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });
  const [errors, setErrors] = useState({
    name_en: '',
    name_ru: '',
    name_uk: '',
  });

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/admin/category/admin_edit/${slug}`,
        null,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setUserData(response.data.response);
    } catch (error) {
      console.error('Error at chnage username at Admin panel', error);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleClick = async () => {
    try {
      const newErrors = {};

      if (userData.name_en === '') {
        newErrors.name_en = 'Category Name (en) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_ru === '') {
        newErrors.name_ru = 'Category Name (ru) is required';
        window.scrollTo(0, 0);
      }
      if (userData.name_uk === '') {
        newErrors.name_uk = 'Category Name (uk) is required';
        window.scrollTo(0, 0);
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          cancelButtonText: 'No',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          title: slug ? 'Update Category?' :'Add Category?',
          text: slug ? 'Do you want to update the category?' : 'Do you want to add this category?',
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          const response = await axios.post(
            slug ? BaseApi + `/admin/category/admin_edit/${slug}` : BaseApi + '/admin/category/admin_add',
            userData,
            {
              headers: {
                key: ApiKey,
                adminid: adminID,
                ContentType: 'application/json',
                Authorization: `Bearer ${tokenKey}`,
              },
            },
          );

          setLoading(false);

          if (response.data.status === 200) {
            Swal.fire({
              icon: 'success',
              confirmButtonText: 'Close',
              title: slug ? 'Category updated successfully!' : 'Category added successfully!',
            });

            navigate('/admin/categories');
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'Close',
              title: response.data.message,
            });
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        confirmButtonText: 'Close',
        text: slug ? 'Could not update category. Please try again later!' : 'Could not add category. Please try again later!',
      });

      console.error(slug ? 'Could not update category!' : 'Could not add category!', error);
    }
  };

  const handleReset = () => {
    setUserData({
      name_en: '',
      name_ru: '',
      name_uk: '',
    });

    setErrors({
      name_en: '',
      name_ru: '',
      name_uk: '',
    });
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      if (slug) {
        getData();
      } else {
        setUserData({
          name_en: '',
          name_ru: '',
          name_uk: '',
        });
      }

      window.scrollTo(0, 0);
    }
  }, [slug, tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      onClick={() => navigate('/admin/categories')}
                    >
                      Categories List
                    </Link>
                    <Typography color='text.primary'>{slug ? 'Edit Category' : 'Add Category'}</Typography>
                  </Breadcrumbs>
                </div>
                <h2 className='adminPageHeading'>{slug ? 'Edit Category' : 'Add Category'}</h2>
                <form className='adminForm'>
                  <div className='mb-5 mt-5'>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='name_uk' className='form-label'>
                        Category Name (uk)<span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_uk'
                        name='name_uk'
                        onChange={handleChange}
                        value={userData.name_uk}
                        placeholder='Category Name (uk)'
                        className={`form-control ${errors.name_uk && 'input-error'}`}
                      />
                      {
                        errors.name_uk && (
                          <div className='text-danger'>{errors.name_uk}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='name_uk' className='form-label'>
                        Category Name (ru)<span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_ru'
                        name='name_ru'
                        onChange={handleChange}
                        value={userData.name_ru}
                        placeholder='Category Name (ru)'
                        className={`form-control ${errors.name_ru && 'input-error'}`}
                      />
                      {
                        errors.name_ru && (
                          <div className='text-danger'>{errors.name_ru}</div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='name_en' className='form-label'>
                        Category Name (en)<span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='name_en'
                        name='name_en'
                        onChange={handleChange}
                        value={userData.name_en}
                        placeholder='Category Name (en)'
                        className={`form-control ${errors.name_en && 'input-error'}`}
                      />
                      {
                        errors.name_en && (
                          <div className='text-danger'>{errors.name_en}</div>
                        )
                      }
                    </div>
                  </div>
                  <div className='adminBottomButtons'>
                    <button
                      type='button'
                      onClick={handleClick}
                      className='btn btn-primary button1'
                    >
                      SAVE
                    </button>
                    <button
                      type='button'
                      className='btn btn-primary button2'
                      onClick={slug ? () => getData() : () => handleReset()}
                    >
                      RESET
                    </button>
                  </div>
                </form>
              </div>
            )
        }
      </div>
    </>
  );
};

export default APAddCategory;
